import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BotIdService {
    private botId!: string;

    public setBotId(botId: string): void {
        this.botId = botId;
    }

    public getBotId(): string {
        return this.botId;
    }
}
